import React from "react";
import { Link } from "react-router-dom";
import { Alert, Form, Input, Button } from "antd";
import { useDispatch } from "react-redux";

import "./Auth.scss";
import { doSignIn } from "../../../modules/auth/stores/thunk";
import { SESSION_EXPIRED_KEY } from "../../../constants";

/**
 * GF-50: did request.js send us here because the API rejected our token?
 *
 * Read WITHOUT clearing, and cleared on a successful sign-in instead (see the
 * auth slice). Reading destructively here would work today, but it breaks the
 * moment anyone adds React.StrictMode: its double mount would consume the flag
 * on the first mount and leave the second — the one the user sees — with
 * nothing to show. A message that silently stops appearing is worse than no
 * message, because nobody notices it is gone.
 *
 * The flag otherwise lives until the tab closes. sessionStorage is per-tab but
 * IS copied into a tab opened from this one (target="_blank", window.open,
 * "Duplicate tab") — so "per-tab" is not the reason this is safe. The reason is
 * that the cookie is gone in that case too, which makes the message true in the
 * new tab as well.
 */
const wasSessionExpired = () => {
  try {
    return sessionStorage.getItem(SESSION_EXPIRED_KEY) === "1";
  } catch (e) {
    return false; // private mode / blocked storage
  }
};

const SignInForm = () => {
  const dispatch = useDispatch();
  const sessionExpired = wasSessionExpired();

  const handleSubmit = (params) => {
    dispatch(doSignIn({ ...params }));
  };

  return (
    <div className={`SignInForm`}>
      <Form
        scrollToFirstError
        layout="vertical"
        hideRequiredMark
        colon={false}
        onFinish={handleSubmit}
      >
        <div className="Logo">
          <Link to="/">
            <img
              src={`/logo.svg`}
              alt="logo"
              style={{maxWidth: "100%"}}
            />
          </Link>
        </div>
        <div className="FormHeader">
          <div className="Title">Logga in på ditt konto</div>
        </div>
        {sessionExpired && (
          /* Says what HAPPENED and why, not that "an error occurred". Without
             this, an ended session is indistinguishable from a broken program,
             which is all of GF-50. An antd Alert rather than a notification on
             purpose: notifications disappear after a few seconds, and someone
             thrown out mid-entry needs time to read why. (The message strings
             themselves stay Swedish — the app's UI language.) */
          <Alert
            type="warning"
            showIcon
            message="Du blev utloggad"
            description="Din inloggning gäller inte längre. Logga in igen för att fortsätta."
            style={{ marginBottom: 16 }}
          />
        )}
        <div className="FormContent">
          <Form.Item
            label="Användarnamn"
            name="email"
            rules={[
              { type: "email", message: "Invalid Email" },
              { required: true, message: "Required" },
            ]}
          >
            <Input
              size="large"
              placeholder="namn@företag.se"
            />
          </Form.Item>
          <Form.Item
            label="Lösenord"
            name="password"
            rules={[{ required: true, message: "Required" }]}
          >
            <Input.Password size="large" placeholder="Lösenord" />
          </Form.Item>
          <div className="ForgotPassword">
            <Link to="/forgot-password">Glömt Lösenord?</Link>
          </div>
        </div>
        <div className="FormFooter">
          <Button type="primary" htmlType="submit" block size="large">
            Logga in
          </Button>
        </div>
      </Form>
      {/* <div className="Register">
        Har du inget konto? <Link to="/register">Registrera här</Link>
      </div> */}
    </div>
  );
};

export default SignInForm;
